import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthorizationComponent } from "./authorization/authorization.component";
import { CarrierComponent } from "./carrier/carrier.component";
import { PlansComponent } from "./plans/plans.component";
import { GroupComponent } from "./group/group.component";
import { NotfoundComponent } from "./notfound/notfound.component";
import { AuthorizationGuard } from "./authorization/authorization.guard";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";

const routes: Routes = [
  {
    path: "",
    component: AuthorizationComponent,
  },
  {
    path: "group/:Id",
    component: GroupComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: "carrier/:Id",
    component: CarrierComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: "plans/:Id",
    component: PlansComponent,
    canActivate: [AuthorizationGuard],
  },
  {
    path: "disclaimer",
    component: DisclaimerComponent,
    canActivate: [AuthorizationGuard],
  },
  { path: "**", component: NotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
